"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _rootLocalStore = _interopRequireDefault(require("../../utils/rootLocalStore"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 上报完成 成功或失败
var complete = function complete() {
  return function (params) {
    var success = params.success,
        data = params.data;

    if (success) {
      // 清除上报成功的数据
      _rootLocalStore.default.delData(data);
    }
  };
};

var _default = complete;
exports.default = _default;